<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp;Insurance</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4">Insurance</h5>
              <div class="search-table container-fluid">
                <div class="row">
                  <div class="col-10">
                    <div class="row">
                      <div class="col col-sm mobile-div">
                        Order ID
                        <input type="text" class="form-control" v-model="searchOrderCode" placeholder="Order ID" />
                      </div>
                      <div class="col col-sm mobile-div">
                        Lessee Name
                        <input type="text" class="form-control" v-model="searchLesseeName" placeholder="Lessee Name" />
                      </div>
                      <div class="col col-sm mobile-div">
                        Insurance Status
                        <multiselect v-model="searchInsuranceStatus" :options="insuranceStatusSelect" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="true" :taggable="true" :close-on-select="false" group-values="libs" group-label="statusAll" :group-select="true"></multiselect>
                      </div>
                      <div class="col col-sm mobile-div">
                        Product Code
                        <input type="text" class="form-control" v-model="searchProductCode" placeholder="Product Code" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col col-sm mobile-div">
                        Start rent (from)
                        <input type="date" class="form-control" v-model="searchStartRentFrom" placeholder="Start Rent From" />
                      </div>
                      <div class="col col-sm mobile-div">
                        Start rent (to)
                        <input type="date" class="form-control" v-model="searchStartRentTo" placeholder="Start rent to" />
                      </div>
                      <div class="col col-sm mobile-div">
                        End rent (from)
                        <input type="date" class="form-control" v-model="searchEndRentFrom" placeholder="Start Rent From" />
                      </div>
                      <div class="col col-sm mobile-div">
                        End rent (to)
                        <input type="date" class="form-control" v-model="searchEndRentTo" placeholder="Start rent to" />
                      </div>
                    </div>
                  </div>
                  <div class="col-2 d-flex flex-column ">
                    <div class="mt-4">
                      <button class="btn btn-primary w-100" @click="searchData">Search</button>
                    </div>
                    <div class="mt-4">
                      <button class="btn btn-secondary w-100 mt-1" @click="exportToExcel">Export</button>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-lg-4 col-sm mobile-div">
                      <input type="text" class="form-control form-control-sm" v-model="orderId" placeholder="Order ID">
                    </div>
                </div>
                <div class="row">
                  <div class="col-lg-3 col-sm mobile-div">
                    Product Name
                    <input type="text" class="form-control" v-model="searchProductName" placeholder="Product Name" />
                  </div>
                </div> -->
              </div>
              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
                <thead class="">
                  <tr>
                    <th><input type="checkbox" @change="selectAllInsurances" :checked="checkIsSelectAll()"></th>
                    <th>Order Details</th>
                    <th>Product Details</th>
                    <th>Year</th>
                    <th style="width: 117px;">Product Code</th>
                    <th>Prorate</th>
                    <th style="width: 126px;">Sum Insured</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingTable == true">
                    <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                  </tr>
                  <tr v-else-if="loadingTable == false && totalData == 0">
                    <td colspan="9" class="text-center">Data not available</td>
                  </tr>
                  <tr v-for="data in dataInsurance" :key="data.orderDetailsId" v-else>
                    <div v-if="selectInsurance.length < 25 || selectInsurance.find(item => item.transId == data.transId)">
                      <td><input type="checkbox" v-model="selectInsurance" :value="data"></td>
                    </div>
                    <div v-else>
                      <td><input type="checkbox" v-model="selectInsurance" :value="data" disabled='true'></td>
                    </div>
                    
                    <td>
                      {{data.orderCode}} <br />
                      {{data.companyName}}<br />
                      Start : {{data.startRent}} <br />
                      End : {{data.endRent}}
                    </td>
                    <td>{{data.productTitle}} {{data.specificationsView}}</td>
                    <td>{{data.year}}</td>
                    <td>{{data.productCode}}</td>
                    <td>{{data.prorate}}</td>
                    <td>{{data.sumInsured}}</td>
                    <td>{{statusInsuranceName(data.insuranceStatus)}}</td>
                    <td class="text-center" v-if="data.replacementID && canRedeclare">
                      <span v-if="data.insuranceStatus == 1" class="link-biru" style="text-decoration: underline;" @click="polis(data.docs)"><i>Polis</i></span>
                      <button class="btn btn-primary btn-sm" @click="handleRedeclareInsurance(data)" > Re-declare </button>
                    </td>
                    <td class="text-center" v-else>
                      <span v-if="data.insuranceStatus != 1 && data.insuranceStatus != 2" class="link-biru" style="text-decoration: underline;" @click="editInsurance(data)"><i>Edit</i></span>
                      <span v-else-if="data.insuranceStatus == 1" class="link-biru" style="text-decoration: underline;" @click="polis(data.docs)"><i>Polis</i></span>
                      <button v-if="data.insuranceStatus == 1 && cancelInsurancePermission" class="btn btn-danger btn-sm" @click="handleCancelInsurance(data)" > Cancel </button>
                    </td>
                  </tr>
                  <tr v-if="!loadingTable">
                    <td colspan="9">
                      <div class="d-flex">
                        <div class="mr-auto">
                          <button class="btn btn-primary" @click="isuedInsurance()">Issue to Insurance</button>
                          <button class="btn btn-primary" @click="notIsuedInsurance()">No Issue Needed</button>
                        </div>
                        <div class="">
                          <div class="" v-if="!prorateEdit" style="float: right;">
                            Current Max Prorate = {{insuranceProrate}}
                            <button class="btn btn-primary ml-1" @click="changeProrateEdit(true)">Edit</button>
                          </div>
                          <div class="" v-if="prorateEdit" style="float: right;">
                            Current Rate = <input type="text" name="" style="width: 50px;" v-model="insuranceProrate" @keypress="isNumber($event)" />
                            <button v-if="insuranceProrate != '' && insuranceProrate >= 0 " class="btn btn-primary ml-1" @click="editProrate()">Save</button>
                            <button v-else class="btn btn-primary ml-1" disabled="">Save</button>
                            <button class="btn btn-danger ml-1" @click="changeProrateEdit(false)">Cancel</button>
                          </div>
                          <div class="" v-if="!rateEdit" style="float: right;padding-right: 10px;">
                            Current Rate = {{insuranceRate}}%
                            <button class="btn btn-primary ml-1" @click="changeRateEdit(true)">Edit</button>
                          </div>
                          <div class="" v-if="rateEdit" style="float: right;padding-right: 10px;">
                            Current Rate = <input type="text" name="" style="width: 50px;" v-model="insuranceRate" @keypress="isNumber($event)" />%
                            <button v-if="insuranceRate != '' && insuranceRate >= 0 " class="btn btn-primary ml-1" @click="editRate()">Save</button>
                            <button v-else class="btn btn-primary ml-1" disabled="">Save</button>
                            <button class="btn btn-danger ml-1" @click="changeRateEdit(false)">Cancel</button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                      <option value="10">10</option>
                      <option value="40">40</option>
                      <option value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                        <li>{{'<'}}</li> 
                      </a> 
                      <a class="page">
                        <li>{{ currentPage }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
              ​
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
    <!-- modalAddEmployee -->
    <div class="modal fade" id="modalEditInsurance" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Edit Insurance Product</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="searchData()">&times;</button>
          </div>
          <div class="modal-body">
            <div>
              <div class="one-line">
                <span class="stPrice-sch">Order ID</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].orderCode" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Product Name</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].productTitle" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Product Code</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].productCode" disabled />
              </div>
            </div>
            <hr />
            <div>
              <div class="one-line">
                <span class="stPrice-sch">Year</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].year" @keypress="isNumber($event)" />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Prorate</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].prorate" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Sum Insured</span>
                <span class="delivery-titik2">:</span>
                <div class="input-group">
                  <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                  <money type="text" class="form-control form-input input-lg" name="price" v-bind="money" @keypress="isNumber($event)" v-model="insuranceEdit[0].sumInsured"></money>
                </div>
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Period From</span>
                <span class="delivery-titik2">:</span>
                <input type="date" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].periodFrom" />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Period To</span>
                <span class="delivery-titik2">:</span>
                <input type="date" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].periodTo" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex">
              <button type="button" class="btn btn-danger btn-sm mr-1" data-dismiss="modal" @onclick="searchData()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="validateEditInsurance()" v-if="loadingButtonSave == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalIsuedInsurance" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Insurance Issuing Confirmation</h4>
            </div>
            <button type="button" class="close" @click="searchData()" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
              <thead class="">
                <tr>
                  <th>Merk/Brand</th>
                  <th>Description/Type</th>
                  <th>Year</th>
                  <th style="width: 117px;">Product Code</th>
                  <th style="width: 117px;">Period From</th>
                  <th style="width: 117px;">Period To</th>
                  <th>Prorate</th>
                  <th style="width: 126px;">Sum Insured</th>
                  <th>Rate</th>
                  <th>Premium</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index)  in selectInsurance" :key="data.orderDetailsId">
                  <td>{{data.productTitle}}</td>
                  <td>{{data.specificationsView}}</td>
                  <td v-if="!data.year" style="background-color: #ff7675;">{{data.year}}</td>
                  <td v-if="data.year">{{data.year}}</td>
                  <td>{{data.productCode}}</td>
                  <td>{{data.startRent}}</td>
                  <td>{{data.endRent}}</td>
                  <td>{{data.prorate}}</td>
                  <td v-if="data.sumInsured <= 0" style="background-color: #ff7675;">{{data.sumInsured}}</td>
                  <td v-if="data.sumInsured > 0">{{data.sumInsured}}</td>
                  <td>{{insuranceRate}}%</td>
                  <td>{{(data.sumInsured * (insuranceRate / 100) * data.prorate / 365).toFixed(2)}}</td>
                  <td class="text-center">
                    <span class="link-biru" style="text-decoration: underline;" @click="deleteIsued(index)"><i>Remove</i></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="d-flex">
              <button type="button" class="btn btn-danger btn-sm mr-1" @click="clearSelected()">Clear All Selected</button>
              <button type="button" class="btn btn-danger btn-sm mr-1" @click="searchData()" data-dismiss="modal">Cancel</button>
              <form>
                <input type="password" name="" style="width: 150px;" placeholder="Your Password" v-model="password" />
              </form>
              <button type="button" class="btn btn-primary btn-sm" disabled="" v-if="!loadingButtonSave && disableSave">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="issuedInsurance()" v-if="!loadingButtonSave && !disableSave">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-if="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalNotIsuedInsurance" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title" style="color: red;">Insurance not Need Issuing Confirmation</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
              <thead class="">
                <tr>
                  <th>Merk/Brand</th>
                  <th>Description/Type</th>
                  <th>Year</th>
                  <th style="width: 117px;">Product Code</th>
                  <th style="width: 117px;">Period From</th>
                  <th style="width: 117px;">Period To</th>
                  <th>Prorate</th>
                  <th style="width: 126px;">Sum Insured</th>
                  <th>Rate</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index)  in selectInsurance" :key="data.orderDetailsId">
                  <td>{{data.productTitle}}</td>
                  <td>{{data.specificationsView}}</td>
                  <td>{{data.year}}</td>
                  <td>{{data.productCode}}</td>
                  <td>{{data.startRent}}</td>
                  <td>{{data.endRent}}</td>
                  <td>{{data.prorate}}</td>
                  <td>{{data.sumInsured}}</td>
                  <td>{{insuranceRate}}%</td>
                  <td class="text-center">
                    <span class="link-biru" style="text-decoration: underline;" @click="deleteIsued(index)"><i>Remove</i></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="d-flex">
              <button type="button" class="btn btn-danger btn-sm mr-1" @click="clearSelected()">Clear All Selected</button>
              <button type="button" class="btn btn-danger btn-sm mr-1" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="notIssuedInsurance()" v-if="!loadingButtonSave">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-if="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalPolis" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">List Polis Docs</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
              <thead class="">
                <tr>
                  <th>From</th>
                  <th>To</th>
                  <th>Prorate</th>
                  <th style="width: 126px;">Sum Insured</th>
                  <th style="width: 126px;">Premium</th>
                  <th>Isued By</th>
                  <th>Isued Time</th>
                  <th>Trx Polis</th>
                  <th>Link Polis</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in polisList" :key="`${data.premiroId}-${index}`">
                  <td>{{data.insuranceFrom}}</td>
                  <td>{{data.insuranceTo}}</td>
                  <td>{{data.insuranceProrate}}</td>
                  <td>{{data.insuranceSum}}</td>
                  <td>{{data.insurancePremium}}</td>
                  <td>{{data.insuranceName}}</td>
                  <td>{{data.insuranceTime}}</td>
                  <td>{{data.premiroId}}</td>
                  <td><a v-bind:href="data.insuranceAsaniUrl+'?token='+token" target="_blank">ASANI</a> | <a v-bind:href="data.insurancePremiroUrl" target="_blank">PREMIRO</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalIsuedInsuranceEmty" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-l">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Ooops</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <h4>Maaf, kamu belum memilih.</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalRedeclareInsurance" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Re-declare Insurance Product</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="searchData()">&times;</button>
          </div>
          <div class="modal-body">
            <div>
              <table class="table table-reponsive">
                <thead>
                  <tr style="background-color : #f8f9fb;">
                    <th> </th>
                    <th>Unit Saat Ini</th>
                    <th>Unit Lama</th>
                  </tr>
                </thead>
                <tbody>
                 
                  <tr>
                    <td>Order ID</td>
                    <td><a href="" @click="toOrderDetail(insuranceEdit[0].newOrderId, insuranceEdit[0].newOrderCode, insuranceEdit[0].companyId, insuranceEdit[0].companyTag, insuranceEdit[0].newOrderTag)">{{insuranceEdit[0].newOrderCode}}</a></td>
                    <td><a href="" @click="toOrderDetail(insuranceEdit[0].orderId, insuranceEdit[0].orderCode, insuranceEdit[0].companyId, insuranceEdit[0].companyTag, insuranceEdit[0].orderTag)">{{insuranceEdit[0].orderCode}}</a></td>
                  </tr>
                  <tr>
                    <td>Product Name</td>
                    <td>{{insuranceEdit[0].newProductTitle}}</td>
                    <td>{{insuranceEdit[0].productTitle}}</td>
                  </tr>
                  <tr class="border-bottom">
                    <td>Product Code</td>
                    <td>{{insuranceEdit[0].newProductCode}}</td>
                    <td>{{insuranceEdit[0].productCode}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div>
              <div class="one-line">
                <span class="stPrice-sch">Order ID</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].orderCode" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Product Name</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].productTitle" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Product Code</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].productCode" disabled />
              </div>
            </div> -->
            <hr />
            <div>
              <div class="one-line">
                <span class="stPrice-sch">Year</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].year" @keypress="isNumber($event)" />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Prorate</span>
                <span class="delivery-titik2">:</span>
                <input type="text" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].prorate" disabled />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Sum Insured</span>
                <span class="delivery-titik2">:</span>
                <div class="input-group">
                  <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                  <money type="text" class="form-control form-input input-lg" name="price" v-bind="money" @keypress="isNumber($event)" v-model="insuranceEdit[0].sumInsured"></money>
                </div>
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Period From</span>
                <span class="delivery-titik2">:</span>
                <input type="date" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].periodFrom" />
              </div>
              <div class="one-line">
                <span class="stPrice-sch">Period To</span>
                <span class="delivery-titik2">:</span>
                <input type="date" class="form-control mt-1 mr-1" name="" v-model="insuranceEdit[0].periodTo" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex">
              <button type="button" class="btn btn-danger btn-sm mr-1" data-dismiss="modal" @onclick="searchData()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="validateRedeclareInsurance()" v-if="loadingButtonSave == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import swal from "sweetalert";
import SideBar from "../SideBar";
import { Money } from "v-money";
export default {
  name: "ResolutionCenterPage",
  components: {
    SideBar,
    Multiselect,
    Money,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      loadingTable: false,
      source: "",
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      searchLesseeName: "",
      searchOrderCode: "",
      searchStartRentFrom: "",
      searchStartRentTo:"",
      searchEndRentFrom: "",
      searchEndRentTo:"",
      searchProductName: "",
      searchProductCode: "",
      searchInsuranceStatus: [],
      insuranceStatusSelect: [{
        statusAll: "All",
        libs: [{
            status: "0",
            statusName: "Pending",
          },
          {
            status: "1",
            statusName: "Issued",
          },
          {
            status: "2",
            statusName: "Not Issued",
          },
          {
            status: "3",
            statusName: "Finished",
          },
          {
            status: "4",
            statusName: "Duplicate LP",
          },
          {
            status: "5",
            statusName: "Duplicate SN",
          },
          {
            status: "replace",
            statusName: "Unit Replaced",
          },
        ],
      }, ],
      dataInsurance: [],
      insuranceRate: "",
      insuranceRateTemp: "",
      insuranceProrate: "",
      insuranceProrateTemp: "",
      loadingButtonSave: false,
      insuranceEdit: [{
        orderCode: "",
        productTitle: "",
        productCode: "",
        newOrderCode: "",
        year: 0,
        prorate: 0,
        sumInsured: 0,
        periodFrom: "",
        periodTo: ""
      }, ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      rateEdit: false,
      prorateEdit: false,
      selectInsurance: [],
      isSelectAll: false,
      polisList: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
      canRedeclare : false,
    };
  },
  methods: {
    toOrderDetail(orderId, orderCode, companyId,companyTag, orderTag){
      let tags = false
      if(companyTag || orderTag) tags = true
       window.open(
        this.$router.resolve({path:'/order/detail/' + orderId, query: {
            orderCode: orderCode,
            companyIdDetail: companyId,
            tags: tags
          }
        }).href, 'blank'
       )
      
    },
    handleCancelInsurance(data) {
      swal({
        title: "",
        text: "Are you sure want to cancel this insurance?",
        icon: "warning",
        buttons:{
          cancel:{
            text:"No",
            value: null,
            visible: true,
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true
          },
        },
        dangerMode: true,
      }).then((value) => {
        if (value) {
          this.$http
            .post(
              process.env.CANCEL_INSURANCE, {
                transInsuranceId: data.transId,
              }, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              if (response.data.status !== 200) {
                swal("Error", response.data.message, "error", {
                  button: "Ok",
                });
              } else {
                swal("Success", "Insurance has been cancelled", "success", {
                  button: "Ok",
                }).then(()=>{
                  location.reload();
                })
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              });
            });
        }
      });
    },
    clearSelected() {
      this.selectInsurance = [];
      $("#modalIsuedInsurance").modal("hide");
      $("#modalNotIsuedInsurance").modal("hide");
    },
    checkIsSelectAll() {
      let checked = 0
      this.dataInsurance.forEach(data => {
        if(this.selectInsurance.find(item => item.transId == data.transId)) {
          checked += 1
        }
      })

      if(checked == this.dataInsurance.length || (this.selectInsurance.length == 25 && checked > 0)) {
        return true
      } else {
        return false
      }
    },
    selectAllInsurances() {
      const isSelectAll = this.checkIsSelectAll()
      console.log(isSelectAll)
      let datas = this.dataInsurance
      if (!isSelectAll) {
        // this.selectInsurance = datas
        // datas.forEach(item => {
        //   const index = this.selectInsurances.findIndex(data => item.transId == data.transId); 
        //   if(this.selectInsurances.find(data => item.transId == data.transId)) {
        //     this.selectInsurance.splice(index, 1);
        //   }
        // })
        datas.forEach(item => {
          if(this.selectInsurance.length < 25 && !this.selectInsurance.find(data => data.transId == item.transId)) {
            this.selectInsurance.push(item)
          }
        })
        localStorage.setItem("selectInsurance", JSON.stringify(this.selectInsurance))
      } else {
        // this.clearSelected()
       datas.forEach(item => {
          const index = this.selectInsurance.findIndex(data => item.transId == data.transId); 
          if(this.selectInsurance.find(data => item.transId == data.transId)) {
            this.selectInsurance.splice(index, 1);
          }
        })
        localStorage.setItem("selectInsurance", JSON.stringify(this.selectInsurance))
        // localStorage.setItem("selectInsurance", JSON.stringify([]))
      }
      console.log('selected all', this.selectInsurance)
    },
    notIssuedInsurance() {
      this.loadingButtonSave = true;
      swal({
        title: "Info",
        text: "Are you sure to not issue the data to insurance?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        if (value) {
          this.$http
            .post(
              process.env.NOT_ISUED_INSURANCE, {
                insurance: this.selectInsurance,
              }, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              if (response.data.status == 202) {
                swal("Error", response.data.message, "error", {
                  button: "Ok",
                });
              } else {
                if (response.data.status == 202) {
                  swal("Error", response.data.message, "error", {
                    button: "Ok",
                  });
                } else {
                  var a = [];
                  localStorage.setItem("selectInsurance", JSON.stringify(a));
                  swal("Success", response.data.message, "success", {
                    button: "Ok",
                  }).then((value) => {
                    location.reload();
                  });
                }
              }
              this.loadingButtonSave = false;
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              });
            });
        }
        this.loadingButtonSave = false;
      });
    },
    issuedInsurance() {

      this.loadingButtonSave = true;
      this.$http
        .post(
          process.env.ISUED_INSURANCE, {
            insurance: this.selectInsurance,
            password: this.password,
          }, {
            timeout: 200 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 202 || response.data.status == 203) {
            swal("Error", response.data.message, "error", {
              button: "Ok",
            });
          } else {
            var a = [];
            localStorage.setItem("selectInsurance", JSON.stringify(a));
            swal("Success", response.data.message, "success", {
              button: "Ok",
            }).then((value) => {
              location.reload();
            });
          }
          this.loadingButtonSave = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              localStorage.setItem("selectInsurance", JSON.stringify([]));
              location.reload()
            }
          });
        });
    },
    editProrate() {
      this.$http
        .post(
          process.env.EDIT_CURRENT_PRORATE, {
            insuranceProrate: this.insuranceProrate,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingButtonSave = false;
          this.prorateEdit = false;
          this.insuranceProrateTemp = this.insuranceProrate;
          swal("Success", "Success Edit Rate Insurance", "success", {
            button: "Ok",
          }).then((value) => {
            location.reload();
          });
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    editRate() {
      this.$http
        .post(
          process.env.EDIT_CURRENT_RATE, {
            insuranceRate: this.insuranceRate,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingButtonSave = false;
          this.rateEdit = false;
          this.insuranceRateTemp = this.insuranceRate;
          swal("Success", "Success Edit Rate Insurance", "success", {
            button: "Ok",
          }).then((value) => {
            location.reload();
          });
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    validateEditInsurance() {
      var message = ""
      if (this.insuranceEdit[0].year == null || this.insuranceEdit[0].year == "" || parseInt(this.insuranceEdit[0].year) < 2000 || parseInt(this.insuranceEdit[0].year) >= 2030) {
        swal("Error", "Year must be valid", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].sumInsured == null || this.insuranceEdit[0].sumInsured == "" || parseInt(this.insuranceEdit[0].sumInsured) <= 0) {
        swal("Error", "Sum Insured must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].periodFrom == null || this.insuranceEdit[0].periodFrom == "") {
        swal("Error", "Period from must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].periodTo == null || this.insuranceEdit[0].periodTo == "") {
        swal("Error", "Period to must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else {
        this.submitEditInsurance()
      }
    },
    validateRedeclareInsurance() {
      var message = ""
      if (this.insuranceEdit[0].year == null || this.insuranceEdit[0].year == "" || parseInt(this.insuranceEdit[0].year) < 2000 || parseInt(this.insuranceEdit[0].year) >= 2030) {
        swal("Error", "Year must be valid", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].sumInsured == null || this.insuranceEdit[0].sumInsured == "" || parseInt(this.insuranceEdit[0].sumInsured) <= 0) {
        swal("Error", "Sum Insured must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].periodFrom == null || this.insuranceEdit[0].periodFrom == "") {
        swal("Error", "Period from must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else if (this.insuranceEdit[0].periodTo == null || this.insuranceEdit[0].periodTo == "") {
        swal("Error", "Period to must be entered", "error", {
          button: "Ok",
        }).then((value) => {});
      } else {
        this.submitRedeclareInsurance()
      }
    },
    submitEditInsurance() {
      var self = this
      this.loadingButtonSave = true;
      this.$http
        .post(
          process.env.EDIT_INSURANCE, {
            data: this.insuranceEdit[0],
            dataLocal: JSON.parse(localStorage.getItem("selectInsurance")),
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingButtonSave = false;
          if (response.data.status == 200) {
            var a = JSON.parse(localStorage.getItem("selectInsurance"));
            var b = this.insuranceEdit[0];
            var c = [];
            var self = this
            a.forEach(function callback(element, index, array) {
              if (element.transId == b.transId) {
                element.year = b.year;
                element.sumInsured = b.sumInsured;
                element.periodFrom = b.periodFrom;
                element.periodTo = b.periodTo;
                element.startRent = self.dateFormat(b.periodFrom);
                element.endRent = self.dateFormat(b.periodTo);
                // element.prorate = response.data.content[0].prorate
              }
              c.push(element);
            });
            localStorage.setItem("selectInsurance", JSON.stringify(c));
            swal("Success", "Success Edit Insurance", "success", {
              button: "Ok",
            }).then((value) => {
              location.reload();
            });
          } else {
            $("#modalEditInsurance").modal("hide");
            swal("Error", response.data.message, "error", {
              button: "Ok",
            }).then((value) => {
              $("#modalEditInsurance").modal("show");
            });
          }
        })
        .catch(error => {
          self.loadingButtonSave = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    submitRedeclareInsurance() {
      var self = this
      this.loadingButtonSave = true;
      this.$http
        .post(
          process.env.REDECLARE_INSURANCE, {
            transInsuranceId: this.insuranceEdit[0].transId,
            sumInsured: this.insuranceEdit[0].sumInsured,
            year: this.insuranceEdit[0].year,
            periodFrom : this.insuranceEdit[0].periodFrom,
            periodTo : this.insuranceEdit[0].periodTo,
            
            dataLocal: JSON.parse(localStorage.getItem("selectInsurance")),
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingButtonSave = false;
          if (response.data.status == 200) {
            var a = JSON.parse(localStorage.getItem("selectInsurance"));
            var b = this.insuranceEdit[0];
            var c = [];
            var self = this
            a.forEach(function callback(element, index, array) {
              if (element.transId == b.transId) {
                element.year = b.year;
                element.sumInsured = b.sumInsured;
                element.periodFrom = b.periodFrom;
                element.periodTo = b.periodTo;
                element.startRent = self.dateFormat(b.periodFrom);
                element.endRent = self.dateFormat(b.periodTo);
                // element.prorate = response.data.content[0].prorate
              }
              c.push(element);
            });
            localStorage.setItem("selectInsurance", JSON.stringify(c));
            swal("Success", "Success Redeclare Insurance", "success", {
              button: "Ok",
            }).then((value) => {
              location.reload();
            });
          } else {
            $("#modalRedeclareInsurance").modal("hide");
            swal("Error", response.data.message, "error", {
              button: "Ok",
            }).then((value) => {
              $("#modalRedelcareInsurance").modal("show");
            });
          }
        })
        .catch(error => {
          self.loadingButtonSave = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    changeRateEdit(a) {
      if (a == false) {
        this.insuranceRate = this.insuranceRateTemp;
      }
      this.rateEdit = a;
    },
    changeProrateEdit(a) {
      if (a == false) {
        this.insuranceProrate = this.insuranceProrateTemp;
      }
      this.prorateEdit = a;
    },
    deleteIsued(e) {
      this.selectInsurance.splice(e, 1);
      if (this.selectInsurance.length == 0) {
        $("#modalIsuedInsurance").modal("hide");
        $("#modalNotIsuedInsurance").modal("hide");
      }
    },
    statusInsuranceName(status) {
      if (status == 0) {
        return "Pending";
      } else if (status == 1) {
        return "Issued";
      } else if (status == 2) {
        return "No Issue";
      } else if (status == 3) {
        return "Finished";
      } else if (status == 4) {
        return "Duplicate LP";
      } else if (status == 5) {
        return "Duplicate SN";
      }
    },
    editInsurance(e) {
      this.insuranceEdit = [];
      this.insuranceEdit.push({
        orderCode: e.orderCode,
        productTitle: e.productTitle,
        productCode: e.productCode,
        year: e.year,
        prorate: e.prorate,
        sumInsured: e.sumInsured,
        orderDetailsId: e.orderDetailsId,
        transId: e.transId,
        periodFrom: e.periodFrom,
        periodTo: e.periodTo,
        startRent: this.dateFormat(e.periodFrom),
        endRent: this.dateFormat(e.periodTo)
      });
      
      if(e.insuranceStatus == 0) {
        this.getSumInsured(e)
      }

      if(this.selectInsurance.length < 1) {
        this.selectInsurance.push(e)
      } else {
        var counter = false
        for(let i in this.selectInsurance) {
          if (this.selectInsurance[i].transId == e.transId) {
            counter = true
            this.insuranceEdit.push(this.selectInsurance[i])
          }
        }
        if (!counter) {
          this.selectInsurance.push(e)
        }
      }
      localStorage.setItem('selectInsurance', JSON.stringify(this.selectInsurance))
      $("#modalEditInsurance").modal("show");
    },
    handleRedeclareInsurance(data) {
      this.insuranceEdit = [];
      this.insuranceEdit.push({
        orderCode: data.orderCode,
        orderId : data.orderId,
        productTitle: data.productTitle + ' ' + data.specificationsView,
        productCode: data.productCode,
        orderTag : data.orderTag,
        newOrderCode: data.newOrderCode,
        newOrderId : data.newOrderId,
        newProductTitle: data.newProductTitle + ' ' + data.specificationsView,
        newProductCode : data.newProductCode,
        newOrderTag : data.newOrderTag,
        companyId : data.companyId,
        companyTag : data.newCompanyTag,
        year: data.year,
        prorate: data.prorate,
        sumInsured: data.sumInsured,
        orderDetailsId: data.orderDetailsId,
        transId: data.transId,
        periodFrom: data.periodFrom,
        periodTo: data.periodTo,
        startRent: this.dateFormat(data.periodFrom),
        endRent: this.dateFormat(data.periodTo)
      });

      if(data.insuranceStatus == 0) {
        this.getSumInsured(data)
      }
      console.log('re-declare')
      localStorage.setItem('selectInsurance', JSON.stringify(this.selectInsurance))
      $("#modalRedeclareInsurance").modal("show");
    },
    polis(e) {
      this.polisList = e;
      $("#modalPolis").modal("show");
    },
    isuedInsurance() {
      if (this.selectInsurance.length > 0) {
        $("#modalIsuedInsurance").modal("show");
      } else {
        $("#modalIsuedInsuranceEmty").modal("show");
      }
    },
    notIsuedInsurance() {
      if (this.selectInsurance.length > 0) {
        // let selectIns = []
        // this.selectInsurance.forEach(el => {
        //   if (el.insuranceStatus == 0 && el.sumInsured > 0) {
        //     selectIns.push(el)
        //   }
        // })
        // this.selectInsurance = selectIns
        $("#modalNotIsuedInsurance").modal("show");
      } else {
        $("#modalIsuedInsuranceEmty").modal("show");
      }
    },
    exportToExcel() {
      this.searchLesseeName = this.$route.query.lesseeName;
      this.searchOrderCode = this.$route.query.orderCode;
      this.searchStartRentFrom = this.$route.query.startRentFrom;
      this.searchStartRentTo = this.$route.query.startRentTo;
      this.searchEndRentFrom = this.$route.query.endRentFrom;
      this.searchEndRentTo = this.$route.query.endRentTo;
      this.searchProductName = this.$route.query.productName;
      this.searchProductCode = this.$route.query.productCode;
      this.searchProductName = this.$route.query.productName;
      this.searchInsuranceStatus = [];
      this.searchInsuranceStatus = JSON.parse(this.$route.query.insuranceStatus);
      var insuranceStatus = [];
      for (var i = 0; i < this.searchInsuranceStatus.length; i++) {
        insuranceStatus.push(this.searchInsuranceStatus[i].status);
      }
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);
      this.$http.post(process.env.NEW_SEARCH_INSURANCE, {
          lesseeName: this.searchLesseeName !== null ? this.searchLesseeName.replace(this.spaceRegex, ' ') : this.searchLesseeName,
          orderCode: this.searchOrderCode !== null ? this.searchOrderCode.replace(this.spaceRegex, ' ') : this.searchOrderCode,
          startRentFrom: this.searchStartRentFrom || '',
          startRentTo: this.searchStartRentTo || '',
          endRentFrom: this.searchEndRentFrom || '',
          endRentTo: this.searchEndRentTo || '',
          productName: this.searchProductName !== null ? this.searchProductName.replace(this.spaceRegex, ' ') : this.searchProductName,
          productCode: this.searchProductCode !== null ? this.searchProductCode.replace(this.spaceRegex, ' ') : this.searchProductCode,
          insuranceStatus: insuranceStatus,
          download: true,
          page: 1,
          itemPerPage: 9999,
        }, { headers: { 
          "Asani-Token": localStorage.getItem("jwt"),
        },
        responseType: 'arraybuffer', })
        .then((response) => {
          console.log("See response", response)
          const a = document.createElement('a')
          const date = new Date
          const reader = new FileReader();
          const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          reader.readAsDataURL(blob);
          reader.onloadend = function (e) {
            a.href = reader.result
            a.download = `Insurance_Data(${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}).xlsx`
            a.click()
          }
        })
        .catch((err) => {
          console.log('ini errornya', err)
          swal("Error", error.message, "error");
        })
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    searchData() {
      this.$router.push({
        path: "/partnership/insurance",
        query: {
          lesseeName: this.searchLesseeName,
          orderCode: this.searchOrderCode,
          startRentFrom: this.searchStartRentFrom,
          startRentTo: this.searchStartRentTo,
          endRentFrom: this.searchEndRentFrom,
          endRentTo: this.searchEndRentTo,
          productName: this.searchProductName,
          productCode: this.searchProductCode,
          insuranceStatus: JSON.stringify(this.searchInsuranceStatus),
          page: 1,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/partnership/insurance",
        query: {
          lesseeName: this.searchLesseeName,
          orderCode: this.searchOrderCode,
          startRentFrom: this.searchStartRentFrom,
          startRentTo: this.searchStartRentTo,
          endRentFrom: this.searchEndRentFrom,
          endRentTo: this.searchEndRentTo,
          productName: this.searchProductName,
          productCode: this.searchProductCode,
          insuranceStatus: JSON.stringify(this.searchInsuranceStatus),
          page: pagePost,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    getData() {
      this.loadingTable = true;
      this.searchLesseeName = this.$route.query.lesseeName;
      this.searchOrderCode = this.$route.query.orderCode;
      this.searchStartRentFrom = this.$route.query.startRentFrom;
      this.searchStartRentTo = this.$route.query.startRentTo;
      this.searchEndRentFrom = this.$route.query.endRentFrom;
      this.searchEndRentTo = this.$route.query.endRentTo;
      this.searchProductName = this.$route.query.productName;
      this.searchProductCode = this.$route.query.productCode;
      this.searchProductName = this.$route.query.productName;
      this.searchInsuranceStatus = [];
      this.searchInsuranceStatus = JSON.parse(this.$route.query.insuranceStatus);
      var insuranceStatus = [];
      this.canRedeclare = false
      for (var i = 0; i < this.searchInsuranceStatus.length; i++) {
        insuranceStatus.push(this.searchInsuranceStatus[i].status);
        if(this.searchInsuranceStatus[i].statusName == 'Unit Replaced') {
          this.canRedeclare = true
        }
      }
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);
      this.$http
        .post(
          process.env.NEW_SEARCH_INSURANCE, {
            lesseeName: this.searchLesseeName !== null ? this.searchLesseeName.replace(this.spaceRegex, ' ') : this.searchLesseeName,
            orderCode: this.searchOrderCode !== null ? this.searchOrderCode.replace(this.spaceRegex, ' ') : this.searchOrderCode,
            startRentFrom: this.searchStartRentFrom,
            startRentTo: this.searchStartRentTo,
            endRentFrom: this.searchEndRentFrom,
            endRentTo: this.searchEndRentTo,
            productName: this.searchProductName !== null ? this.searchProductName.replace(this.spaceRegex, ' ') : this.searchProductName,
            productCode: this.searchProductCode !== null ? this.searchProductCode.replace(this.spaceRegex, ' ') : this.searchProductCode,
            insuranceStatus: insuranceStatus,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.dataInsurance = response.data.content.data;
          this.totalPage = response.data.content.totalPage;
          this.totalData = response.data.content.totalData;
          this.currentPage = response.data.content.currentPage;
          this.insuranceRate = response.data.content.insuranceRate;
          this.insuranceRateTemp = response.data.content.insuranceRate;
          this.insuranceProrate = response.data.content.insuranceProrate;
          this.insuranceProrateTemp = response.data.content.insuranceProrate;

          // Update Selected Insurance Data (because new data have different prorate)
          this.selectInsurance.forEach(item => {
            const insuranceData = this.dataInsurance.find(data => data.transId == item.transId)
            if(insuranceData) {
              item.prorate = insuranceData.prorate
            }
          })

          window.localStorage.setItem('selectInsurance', JSON.stringify(this.selectInsurance))

          this.loadingTable = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    dateFormat($date) {
      const d = new Date($date)
      if (d.getDate().toString().length == 1) {
        var date = '0' + d.getDate().toString()
      } else {
        date = d.getDate()
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = '0' + (d.getMonth() + 1).toString()
      } else(
        month = (d.getMonth() + 1)
      )
      return date + '-' + month + '-' + d.getFullYear()
    },
    getSumInsured(data) {
      this.$http
        .get(
          `${process.env.GET_SUM_INSURED}/${data.productId}`, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.data.content && data.insuranceStatus == 0 && !data.sumInsured) {
            this.insuranceEdit[0].sumInsured = response.data.content
          }     
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });

    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.selectInsurance = localStorage.getItem("selectInsurance") ? JSON.parse(localStorage.getItem("selectInsurance")) : [];
    this.getData();
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
  },
  watch: {
    insuranceRate: function (a) {
      if (a.length > 1 && a[0] == "0" && a[1] != ".") {
        this.insuranceRate = a.slice(1);
      }
    },
    selectInsurance: function (a) {
      this.disableSave = false;
      localStorage.setItem("selectInsurance", JSON.stringify(a));
      for (var i = 0; i < a.length; i++) {
        if (a[i].year == null || a[i].sumInsured == "0") {
          this.disableSave = true;
        }
      }
    },
  },
  // computed: {
  //   reversedMessage: function () {
  //     localStorage.setItem('selectInsurance', this.selectInsurance)
  //     return ''
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partnership/InsurancePage.vue